<template>
    <div class="container-fluid mt-4" v-if="$isAllowed('read')">
        <div class="row">
            <div class="col-12">
                <cph-widget>
                    <h2 slot="header">API browser</h2>
                    <api-browser :routes="routes" slot="body"/>
                </cph-widget>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import {ConfigPerimeter} from '../../../router/perimeters/configPerimeter';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import ApiBrowser from '../../../components/Panel/Account/ApiBrowser/ApiBrowser';
import {mapMutations, mapActions} from 'vuex';

export default {
    name: 'ApiBrowserView',
    data () {
        return {
            routes: []
        };
    },
    components: {
        ApiBrowser,
        CphWidget
    },
    perimeters: [
        ConfigPerimeter
    ],
    methods: {
        ...mapMutations(['updateLoadingState']),
        ...mapActions(['getApiAsync']),
        async fetchData () {
            this.updateLoadingState(true);
            try {
                this.routes = await this.getApiAsync();
            } catch (err) {
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'to load api'
                });
                this.routes = [];
                throw new Error(err);
            } finally {
                this.updateLoadingState(false);
            }
        }
    },
    created () {
        this.fetchData();
    }
};
</script>
